import { DividerSmall } from '@wix/wix-ui-icons-common';

import defaultComponentData from './../ricos-schema/legacy/statics/divider.defaults.json';
import {
  type EditorPlugin,
  type EditorPluginCreator,
  quickActionsModalSections,
  RicosPluginToolbarNames,
} from './../ricos-types';
import { changeSelectionToEndOfTextBlock } from './../wix-rich-content-common';

import { DEFAULTS } from './defaults';
import { dividerConverter } from './divider-converter';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { tiptapExtensions } from './tiptap/tiptap';
import type { DividerPluginEditorConfig } from './types';
import { DIVIDER_TYPE } from './types';

export const pluginDivider: EditorPluginCreator<DividerPluginEditorConfig> = config => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    pmMarkConverters: [],
    pmNodeConverters: [dividerConverter],
    type: DIVIDER_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.DIVIDER],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    getQuickActions: () => [
      {
        id: 'divider',
        title: 'QuickActionsPlugin_ActionTitle_Divider',
        icon: DividerSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ['separator', 'line', 'break', 'horizontal rule', 'section divider'],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          publicCommands.insertBlockWithBlankLines(DIVIDER_TYPE, defaultComponentData);
        },
      },
    ],
  } as EditorPlugin;
};
